import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import CreateCampaignDialogErrorMixin from './create-campaign-dialog-error-mixin';

@Component
export default class CreateCampaignDialogFlowRuleErrorsMixin extends mixins(CreateCampaignDialogErrorMixin) {
  getRuleErrorCondition(ruleIndex: number): any[] {
    return [
      'rules', ruleIndex + 1,
    ];
  }

  get isNoConditionErrorCondition() {
    return [ 'VALIDATION_FLOW_RULE_AT_LEAST_ONE_CONDITION', 'conditions'];
  }

  get isAtLeastOneActivePathCondition() {
    return [ 'VALIDATION_FLOW_AT_LEAST_ONE_ACTIVE_PATH',  'paths', 0];
  } 

  get isNotPathErrorCondition() {
    return [ 'paths' ];
  }

  get isNoConditionError() {
    return this.getInvalidFieldsError(this.isNoConditionErrorCondition);
  }

  get isAnyRuleHasError() {
    return this.getInvalidFieldsError([ 'VALIDATION_FLOW_CONDITION_EMPTY_PARAMETER' ]);
  }

  get isAtLeastOneActivePathError() {
    return this.getInvalidFieldsError(this.isAtLeastOneActivePathCondition);
  }
}